module.exports = __webpack_public_path__ + "img/logo-branco-ultragaz.6619b175.svg";